import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ReportParams } from './store/report-params.model';
import { Report } from './store/report.model';
import { ReportFavoriteParams } from './store/favorite-params.model';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private reportUri = `${environment.apiLocation}/Reports`;
    private paramsUri = `${environment.apiLocation}/ReportParms`;
    private favoriteUri = `${environment.apiLocation}/ReportFavorite`;

    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    public get(EmployeeListID: string): Observable<Array<Report>> {
        return this.http
            .get<Array<Report>>(`${this.reportUri}/${EmployeeListID}`)
            .pipe(
                // retryBackoff({
                //     initialInterval: 1000,
                //     maxRetries: 5
                // }),
                tap(data =>
                    this.log.verbose({ type: 'ReportService:get', data })
                )
            );
    }
    public postParams(params: ReportParams): Observable<any> {
        this.log.verbose({ type: 'ReportService:postParams', params });
        return this.http.post<any>(this.paramsUri, params).pipe(
            tap(x =>
                this.log.verbose({
                    type: 'ReportService:postParams:response',
                    x
                })
            )
        );
        // .toPromise()
    }
    public favoriteReport(params: ReportFavoriteParams): Observable<any> {
        this.log.verbose({ type: 'ReportService:favoriteReport', params });
        return this.http.post<any>(this.favoriteUri, params).pipe(
            tap(x =>
                this.log.verbose({
                    type: 'ReportService:favoriteReport:response',
                    x
                })
            )
        );
        // .toPromise()
    }
}
